import { default as olMap } from 'ol/Map.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import * as olProj from 'ol/proj.js';
import * as olCoord from 'ol/coordinate.js';
import Feature from 'ol/Feature.js';
import {Style, Fill, Stroke, Circle} from 'ol/style.js';
import Point from 'ol/geom/Point.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import {defaults as defaultControls} from 'ol/control/defaults.js';
import { default as olGeolocation } from 'ol/Geolocation.js';
import {getRegion} from './config.js';
import FormatData from './FormatData.js';
import Library from './Library.js';

export class Map {
    target = "map";
    appName = "default";
    server = "https://avn.vietorweather.net";
    //server = "http://avn.devomain";
    settings = {
        "refresh": 10,
        "locate": [30, -97, 4],
        "units": "us",
        "fcst": false,
        "tracking": false,
        "hover": false
    };
    secs = undefined;
    init_secs = undefined;
    fixed_time = false;
    level = undefined;
    controls = [];
    layers = [];
    view = undefined;
    search = undefined;
    formatter = undefined;
    geolocate = undefined;
    position = undefined;
    position_layer = undefined;
    timeout_id = undefined;
    loading = 0;

    constructor(settings = {}){
        Object.assign( this.settings, settings );
        let map_options = { 
            "target": this.target,
            "controls": defaultControls({ "zoom": true, "attribution": false, "rotate": true })
        };
        this.map = new olMap( map_options );

        let val;
        this.search = new URLSearchParams(window.location.search);
        // Setup date
        this.secs = new Date().getTime()/1000;
        if( val = this.search.get("date")){
            this.init_secs = Library.getSeconds( val );
            this.secs = this.init_secs;
            this.fixed_time = true;
        } else 
            this.init_secs = this.secs;
        // Setup hover
        let state = JSON.parse(localStorage.getItem( this.appName + ".hover"));
        if( state ) this.settings['hover'] = state;
        if( val = this.search.get('hover')) 
            this.settings['hover'] = Library.getBoolean(val);

        // Setup level
        state = JSON.parse(localStorage.getItem( this.appName + ".level"));
        if( state ) this.level = state;
        console.info( state );
        if( val = this.search.get('level')) 
            this.level = val;

        this.formatter = new FormatData(this.settings['units']);

        this.setupInteractions();
        this.getViews();
    }

    addControl( control ){
        this.controls.push( control );
        if( control.control ) this.map.addControl( control.control );
    }

    addLayer( layer ){
        this.layers.push( layer );
        if( layer.layer ) this.map.addLayer( layer.layer );
    }

    getAppName(){
        return this.appName;
    }

    getLocation(){
        let center = this.view.getCenter();
        let loc = new olProj.toLonLat(center);
        return [loc[1], loc[0], this.view.getZoom() ];
    }

    getViews(){
        for( let i = 1; i <= 4; i++ ){
            let state = JSON.parse(localStorage.getItem( this.appName + ".view."+i));
            if( state ){
                let [name, lat, lon, zoom] = state;
                let elem;
                if( elem = document.getElementById("user-"+i)){
                    // Add to drop down
                    elem.href = "javascript:map.setLocation("+lat+","+lon+","+zoom+")";
                    elem.style.display = "block";
                    elem.innerHTML = name;
                }
                if( elem = document.getElementById("viewname-"+i)){
                    // Add name to config menu
                    elem.value = name;
                }
            }
        }
    }

    get( key ){
        return this.options[key];
    }

    loadingStart(){
        this.loading++;
        if( this.loading == 1 ){
            let elem = document.getElementById("loading");
            console.info( 'show loading');
            if( elem ) elem.style.display = "block";
        }
        console.info( 'loading start', this.loading );
    }
    
    loadingEnd(){
        this.loading--;
        if( this.loading <= 0 ){
            console.info( 'hide loading');
            let elem = document.getElementById("loading");
            if( elem ) elem.style.display = "none";     
        }
             
        console.info( 'loading end', this.loading );
    }
    
    popupHandler( evt ){
        const coordinate = evt.coordinate;
        const latlon = olCoord.format(olProj.toLonLat(coordinate), "{y},{x}", 3);
        const header = document.getElementById('popup-header');
        const content = document.getElementById('popup-content');

        header.innerHTML = 'DATA at: ' + latlon + '';
        let text = "";
        let features = evt.map.getFeaturesAtPixel(evt.pixel);
        
        for( let ind in features ){
            let lay = this.searchLayer( features[ind].get('data'));
            if( lay ) text += lay.getPopupText( features[ind] );
            console.info( 'lay', lay );
        }

        content.innerHTML = text;
        if( text == "" ) 
            this.popup.setPosition(undefined);
        else
            this.popup.setPosition(coordinate);
    };

    refresh(){
        for( let lay in this.layers )
            this.layers[lay].refresh();
    }

    saveState(){
        for( let lay in this.layers )
            this.layers[lay].saveState();
        for( let ctl in this.controls )
            this.controls[ctl].saveState();
        localStorage.setItem( this.appName + ".location", JSON.stringify(this.getLocation()));
        localStorage.setItem( this.appName + ".hover", JSON.stringify(this.settings['hover']));
        if( this.level ){
            console.info( this.level );
            localStorage.setItem( this.appName + ".level", JSON.stringify(this.level));
        }
    }

    saveView(num){
        let values = this.getLocation();
        let elem;
        if( elem = document.getElementById("viewname-"+num) ){
            let name = elem.value;
            values.unshift( name );
            let key = this.appName + ".view."+num;
            if( name != "" )
                localStorage.setItem( key, JSON.stringify(values));
            else
                localStorage.removeItem(key);
            if( elem = document.getElementById("user-"+num)){
                elem.href = "javascript:map.setLocation("+values[1]+","+values[2]+","+values[3]+")";
                elem.innerHTML = name;
                if( name != "" )
                    elem.style.display = "block";
                else
                    elem.style.display = "none";
            }
        }
    }

    searchControl( type ){
        for( let ctl in this.controls ){
            if( this.controls[ctl].name == type.toLowerCase() ) return this.controls[ctl];
        }
        return null;
    }

    searchLayer( type ){
        if( type == null ) return null;
        for( let lay in this.layers ){
            if( this.layers[lay].name == type.toLowerCase() ) return this.layers[lay];
        }
        return null;
    }

    set( key, val ){
        if( key == "hover" ){
            this.settings[key] = Library.getBoolean(val);
            return 1;
        }
        if( key == "units" ){
            this.formatter.setUnits(val);
            return 1;
        }
        if( key in this.settings ){
            this.settings[key] = val;
            return 1;
        }
        return 0;
    }

    setDate( val ){
        if( val == undefined )
            this.secs = new Date().getTime()/1000;
        else 
            this.secs = val;
    }

    setInitDate( val ){
        if( val == undefined )
            this.init_secs = new Date().getTime()/1000;
        else 
            this.init_secs = val;
    }

    setHover(val){
        val = Library.getBoolean(val);
        if( val ){
            this.map.un('click', this.popupHandlerRef );
            this.map.on('pointermove', this.popupHandlerRef);
        } else {
            this.map.un('pointermove', this.popupHandlerRef);
            this.map.on('click', this.popupHandlerRef);
        }
        this.settings["hover"] = val;
    }

    setLocation( lat, lon, zoom ){
        let val;

        if( lat == undefined ){
            let state = JSON.parse(localStorage.getItem( this.appName + ".location"));
            if( state ) [lat, lon, zoom] = state;
        }
        if( typeof lat == "object" ){
            let dat = lat;
            [lat, lon, zoom] = dat;
        }
        if( val = this.search.get('locate')){
            [lat,lon,zoom] = val.split(',');
        }
        if( lat == "gps" )
            this.setTracking(true);
        else {
            this.setTracking(false);
            if( lon == undefined )
                [lat, lon, zoom] = getRegion( lat );
        }
        
        if( this.view ){
            this.view.setCenter( olProj.fromLonLat([lon, lat]));
            this.view.setZoom( zoom );
        } else {
            let view_opts = {
                "center": olProj.fromLonLat([lon, lat]),
                "zoom": zoom
            }
            this.view = new View( view_opts );
            this.map.setView( this.view );
        }
        
        return 1;
    }

    setupInput(){
        let elems = document.querySelectorAll('[id^=toggle_lyr]');
        let ctl, lyr;
        for( let i = 0; i < elems.length; i++ ){
            let name = elems[i].id.replace("toggle_lyr_","");
            if( lyr = this.searchLayer(name)){
                elems[i].checked = lyr.get('visible');
            }
        }

        elems = document.querySelectorAll('[id^=select]');
        for( let i = 0; i < elems.length; i++ ){
            let name = elems[i].id.replace("select_","");
            let out = name.matchAll( /([a-z_]+)_([a-z]+)$/g );
            for( let match of out ){
                if( lyr = this.searchLayer(match[1]) ){
                    let val = lyr.get(match[2]);
                    for( let j = 0; j < elems[i].options.length; j++ ){
                        if( elems[i].options[j].value == val ){
                            console.info( 'found');
                            elems[i].selectedIndex = j;
                        }
                            
                    }
                } else if( ctl = this.searchControl(match[1]) ){
                    let val = ctl.get(match[2]);
                    for( let j = 0; j < elems[i].options.length; j++ ){
                        if( elems[i].options[j].value == val )
                            elems[i].selectedIndex = j;
                    }
                }
            }
        }

        elems = document.querySelectorAll('[id^=check]');
        for( let i = 0; i < elems.length; i++ ){
            let name = elems[i].id.replace("check_","");
            if( name == "hover" ){
                elems[i].checked = this.settings['hover']
                continue;
            }
            let out = name.matchAll( /([a-z_]+)_([a-z]+)$/g );
            for( let match of out ){
                if( lyr = this.searchLayer(match[1]) ){
                   elems[i].checked = lyr.get( match[2] );
                }
            }
        }

        elems = document.querySelectorAll('[id^=entry]');
        for( let i = 0; i <  elems.length; i++ ){
            let name = elems[i].id.replace("entry_","");
            let out = name.matchAll( /([a-z_]+)_([a-z]+)$/g );
            for( let match of out ){
                if( lyr = this.searchLayer(match[1]) ){
                   elems[i].value = lyr.get( match[2] );
                }
            }
        }
    }

    setupInteractions(){
        // Setup popup
        const container = document.getElementById('popup');
        this.popup = new Overlay({
                "element": container,
                "autoPan": {
                    "animation": {
                    "duration": 250,
                },
                }
                });
        this.map.addOverlay( this.popup );
        const closer = document.getElementById('popup-closer');
        if( closer ){
            closer.onclick = (evt) => ((arg) => {
                arg.popup.setPosition(undefined);
                closer.blur();
                return false;
            })(this);
        }
        
        this.popupHandlerRef = this.popupHandler.bind(this);
        if( this.settings['hover'] )
            this.map.on('pointermove', this.popupHandlerRef );
        else
            this.map.on('click', this.popupHandlerRef );
        // Geolocation
        this.geolocate = new olGeolocation({
                "projection": this.map.getView().getProjection(),
                "tracking": false
                });
        // Visibility change
        document.addEventListener( "visibilitychange", this.visibilityState.bind(this) );
    }

    setTimeout(){
        this.timeout_id = setTimeout( this.updateTime.bind(this), 
                this.settings['refresh']*60000 );
    }

    setTracking(val){
        if( val == undefined ) val = this.settings['tracking']? false: true;
        this.settings['tracking'] = val;
        Library.setCheckbox("tracking", val);
        if( val ){
            this.position = new Feature();
            this.position.setStyle((
                new Style({
                    image: new Circle({
                        "radius": 6,
                        fill: new Fill({
                            "color": '#3333FF'
                        }),
                        "stroke": new Stroke({
                            "color": '#fff',
                            "width": 2
                        }),
                    })
                })
            ));
            this.position_layer = new VectorLayer({
                "map": this.map,
                "source": new VectorSource({
                    "features": [this.position]
                    })
            });

            this.geolocate.setTracking( true );
            console.info( this.geolocate.getPosition());

            // Recenter the map
            this.geolocate.once('change:position', (evt) => ((arg) => {
                let pos = arg.geolocate.getPosition();
                arg.map.getView().setCenter(arg.geolocate.getPosition());
                arg.map.getView().setZoom( 10 );
                })(this));

            // Move geolocate circle
            this.geolocate.on( 'change:position', (evt) => ((arg) => {
                let coord = arg.geolocate.getPosition();
                arg.position.setGeometry(coord ? new Point(coord): null );
                })(this));
        }
        else {
            console.info( 'tracking off');
            this.geolocate.setTracking(false);
            if( this.position_layer ) 
                this.position_layer.setVisible(false);
        }
        return this.settings['tracking'];
    }

    setVisible( layer, val ){
        let lay = this.searchLayer( layer );
        return lay.setVisible( val );
    }

    visibilityState(){
        if( document.visibilityState === "hidden" )
            this.saveState(map);
    }
    
    updateTime(val){
        this.setDate(val);
        this.init_secs = this.secs;
        console.info( 'refresh', Library.formatDate( "", this.secs ));
        for( let lay in this.layers )
            if( this.layers[lay].dynamic['time'] ) this.layers[lay].updateTime();
        let ctl;
        if( ctl = this.searchControl('date_label')) ctl.refresh();
        if( ctl = this.searchControl('time_slider')) ctl.refresh();
        this.timeout_id = setTimeout( this.updateTime.bind(this), 
                this.settings['refresh']*60000 );
    }
}